import { BodyTypeSelector } from '@at/design-system-elements'
import { ThemeSelectors } from '@at/design-system-foundation'
import styled from 'styled-components'

export const NewStyledSearchFiltersBodyTypeContainer = styled.ul`
    width: 100%;
    padding: 0;
    margin-top: -${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};

    & > li {
        max-width: 100%;
        margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
    }
`

export const StyledBodyTypeSelector = styled(BodyTypeSelector)`
    &.body-type-selector {
        div {
            :nth-child(3) {
                padding-right: 4px;
            }
            label {
                padding: 0 12px;
            }
        }
    }
`
